import { Avatar, makeStyles, Paper, Typography } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    overflowX: "auto",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "none",
    padding: theme.spacing(1),
    "& > *": {
      marginRight: theme.spacing(1)
    },
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column"
    }
  },
  avatar: {
    width: "auto",
    height: "auto",
    maxWidth: 288,
    maxHeight: 96,
    "& > img": {
      width: "auto",
      height: "auto",
      maxWidth: 288,
      maxHeight: 96
    }
  },
  text: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap"
  }
}));

const SponsoredSession = ({ session: { exhibitors } }) => {
  const intl = useIntl();
  const classes = useStyles();

  if (!exhibitors || exhibitors?.length === 0) return null;

  return (
    <Paper className={classes.root}>
      <Typography variant="h6" className={classes.text}>
        <i>
          {intl.formatMessage({
            id: "Sessions.SponsoredSession.SponsoredBy",
            defaultMessage: "This session is sponsored by:"
          })}
        </i>
      </Typography>
      {exhibitors.map(({ id, name, logo }) => (
        <Link to={`/companies/${id}`}>
          {logo ? (
            <Avatar variant="square" src={logo} alt={name} className={classes.avatar} />
          ) : (
            <Typography variant="h6" className={classes.text}>
              <strong className={classes.text}>{name}</strong>
            </Typography>
          )}
        </Link>
      ))}
    </Paper>
  );
};

export default SponsoredSession;
